<ion-menu side="end" contentId="main" [appHideScrollbar] menuId="ingamemenu">
    <div [dcBgColor]="menuBackgroundColor()" class="flex h-full flex-col overflow-y-auto">
        <div class="flex items-center space-x-4 px-4 pt-safe-offset-4">
            <app-option-button icon="settings" [clickable]="false"></app-option-button>
            <div dcTypography="bulevar-32" [dcColor]="menuTextColor()" [translate]="'SETTINGS'" i18n="@@SETTINGS">
                Settings
            </div>
        </div>

        @if (authService.user && inGameMode() && inGameDetails()) {
            @if (inGameMode() === 'match') {
                <div dcTypography="geist-9-semibold" class="mx-2 mt-6 flex flex-wrap items-start gap-2 rounded">
                    <div class="game-stats-badge">
                        {{ inGameDetails().start_with | entryMode }}
                    </div>
                    <div class="game-stats-badge">
                        {{ inGameDetails().end_with | finishMode }}
                    </div>
                    @if (inGameDetails().two_legs_difference) {
                        <div class="game-stats-badge" [translate]="'TWO_LEGS_DIFFERENCE'" i18n="@@TWO_LEGS_DIFFERENCE">
                            Two legs difference
                        </div>
                    }
                    @if (inGameDetails().enable_sudden_death) {
                        <div class="game-stats-badge" [translate]="'SUDDEN_DEATH_MODE'" i18n="@@SUDDEN_DEATH_MODE">
                            Sudden death mode
                        </div>
                    }
                </div>
            }

            <div class="mt-4 space-y-1">
                <!-- General -->
                <div>
                    <div
                        [dcBgColor]="menuSectionHeaderBackgroundColor()"
                        dcTypography="bulevar-24"
                        [dcColor]="menuTextColor()"
                        class="px-4 py-2"
                        [translate]="'GENERAL'"
                        i18n="@@GENERAL">
                        General
                    </div>
                    <div
                        [dcBgColor]="menuSectionBackgroundColor()"
                        class="dc-surface-page divide-y-1 divide-divider-color">
                        @if (inGameMode() === 'match') {
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.showCheckoutHint()"
                                mode="game_menu"
                                (itemChange)="toggleShowCheckoutHint()"
                                [translate]="'SHOW_CHECKOUT'"
                                i18n="@@SHOW_CHECKOUT">
                                Show checkout
                            </app-toggle-switch>
                            @if (inGameDetails().is_online) {
                                @if (!isOnlineGroupGame()) {
                                    <app-toggle-switch
                                        dcTypography="geist-14-semibold"
                                        [dcColor]="menuTextColor()"
                                        class="block w-full px-4 py-2"
                                        [model]="preferenceService.enableInGameVoiceCall()"
                                        mode="game_menu"
                                        (itemChange)="toggleEnableInGameVoiceCall()"
                                        [translate]="'ENABLE_IN_GAME_VOICE_CALL'"
                                        i18n="@@ENABLE_IN_GAME_VOICE_CALL">
                                        Enable in-game voice call
                                    </app-toggle-switch>
                                }
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    [dcColor]="menuTextColor()"
                                    class="block w-full px-4 py-2"
                                    [model]="preferenceService.showConfirmThrowout()"
                                    mode="game_menu"
                                    (itemChange)="toggleShowConfirmThrowout()"
                                    [translate]="'CONFIRM_CHECKOUT'"
                                    i18n="@@CONFIRM_CHECKOUT">
                                    Confirm checkout
                                </app-toggle-switch>
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    [dcColor]="menuTextColor()"
                                    class="block w-full px-4 py-2"
                                    [model]="preferenceService.showSpectatorCount()"
                                    mode="game_menu"
                                    (itemChange)="toggleShowSpectatorCount()"
                                    [translate]="'SHOW_SPECTATOR_COUNT'"
                                    i18n="@@SHOW_SPECTATOR_COUNT">
                                    Show spectator count
                                </app-toggle-switch>
                            }
                        }
                        @if (
                            inGameDetails().is_online &&
                            (inGameMode() === 'match' || inGameMode() === 'cricket_tactics')
                        ) {
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.showInGameChat()"
                                mode="game_menu"
                                (itemChange)="toggleShowInGameChat()"
                                [translate]="'SHOW_IN_GAME_CHAT'"
                                i18n="@@SHOW_IN_GAME_CHAT">
                                Show in-game chat
                            </app-toggle-switch>
                        }
                        <app-toggle-switch
                            dcTypography="geist-14-semibold"
                            [dcColor]="menuTextColor()"
                            class="block w-full px-4 py-2"
                            [model]="preferenceService.autoSubmitScore()"
                            mode="game_menu"
                            (itemChange)="toggleAutoSubmitScore()"
                            [translate]="'AUTO_SUBMIT'"
                            i18n="@@AUTO_SUBMIT">
                            Auto submit
                        </app-toggle-switch>
                        @if (!inGameDetails().is_online) {
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.confirmUndoTurn()"
                                mode="game_menu"
                                (itemChange)="toggleConfirmUndoTurn()"
                                [translate]="'CONFIRM_UNDO_TURN'"
                                i18n="@@CONFIRM_UNDO_TURN">
                                Confirm Undo Turn
                            </app-toggle-switch>
                        }
                    </div>
                </div>

                <!-- Audio -->
                <div>
                    <div
                        [dcBgColor]="menuSectionHeaderBackgroundColor()"
                        dcTypography="bulevar-24"
                        [dcColor]="menuTextColor()"
                        class="px-4 py-2"
                        [translate]="'SOUND_SETTINGS'"
                        i18n="@@SOUND_SETTINGS">
                        Audio
                    </div>
                    <div
                        [dcBgColor]="menuSectionBackgroundColor()"
                        class="dc-surface-page divide-y-1 divide-divider-color">
                        <app-toggle-switch
                            dcTypography="geist-14-semibold"
                            [dcColor]="menuTextColor()"
                            class="block w-full px-4 py-2"
                            [model]="preferenceService.allowCaller()"
                            mode="game_menu"
                            (itemChange)="toggleAllowCaller()">
                            MasterCaller
                        </app-toggle-switch>
                        @if (appFeaturesService.enabledAppFeatures().speech_to_score) {
                            <div
                                (click)="showSpeechToScore()"
                                dcTypography="geist-12-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [translate]="'SPEECH_TO_SCORE'"
                                i18n="@@SPEECH_TO_SCORE">
                                Speech to score
                            </div>
                        }
                    </div>
                </div>

                <!-- Advanced sound settings -->
                @if (
                    inGameMode() === 'match' ||
                    inGameMode() === 'cricket_tactics' ||
                    inGameMode() === 'around_the_clock' ||
                    inGameMode() === 'shanghai' ||
                    inGameMode() === 'bobs_27' ||
                    inGameMode() === 'halve_it'
                ) {
                    <div>
                        @if (inGameMode() === 'match' || (inGameDetails().is_online && inGameMode() === 'match')) {
                            <div
                                [dcBgColor]="menuSectionHeaderBackgroundColor()"
                                dcTypography="bulevar-24"
                                [dcColor]="menuTextColor()"
                                class="px-4 py-2"
                                [translate]="'ADVANCED_SOUND_SETTINGS'"
                                i18n="@@ADVANCED_SOUND_SETTINGS">
                                Advanced sound settings
                            </div>
                        }
                        <div
                            [dcBgColor]="menuSectionBackgroundColor()"
                            class="dc-surface-page divide-y-1 divide-divider-color">
                            @if (inGameMode() === 'match') {
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    [dcColor]="menuTextColor()"
                                    class="block w-full px-4 py-2"
                                    [model]="preferenceService.callYouRequire() && preferenceService.allowCaller()"
                                    mode="game_menu"
                                    [disabled]="!preferenceService.allowCaller()"
                                    (itemChange)="toggleCallYouRequire()"
                                    [translate]="'CALL_YOU_REQUIRE'"
                                    i18n="@@CALL_YOU_REQUIRE">
                                    'You require'
                                </app-toggle-switch>
                            }
                            @if (inGameDetails().is_online && inGameMode() === 'match') {
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    [dcColor]="menuTextColor()"
                                    class="block w-full px-4 py-2"
                                    [model]="preferenceService.callOmniImmediately()"
                                    mode="game_menu"
                                    (itemChange)="toggleCallOmniImmediately()"
                                    [translate]="'CALL_OPPONENT_OMNI_IMMEDIATELY'"
                                    i18n="@@CALL_OPPONENT_OMNI_IMMEDIATELY">
                                    Play opponents Omni score immediately
                                </app-toggle-switch>
                            }
                        </div>
                    </div>
                }

                @if (inGameMode() === 'match') {
                    <!-- Statistics -->
                    <div>
                        <div
                            [dcBgColor]="menuSectionHeaderBackgroundColor()"
                            dcTypography="bulevar-24"
                            [dcColor]="menuTextColor()"
                            class="px-4 py-2"
                            [translate]="'STATISTICS'"
                            i18n="@@STATISTICS">
                            Statistics
                        </div>
                        <div
                            [dcBgColor]="menuSectionBackgroundColor()"
                            class="dc-surface-page divide-y-1 divide-divider-color">
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.showAvg()"
                                mode="game_menu"
                                (itemChange)="toggleShowAvg()"
                                [translate]="'SHOW_AVG_IN_MATCH'"
                                i18n="@@SHOW_AVG_IN_MATCH">
                                Show avg. in match
                            </app-toggle-switch>
                        </div>
                    </div>
                }

                @if (
                    appFeaturesService.enabledAppFeatures().action_replays &&
                    hasCameraEnabled() &&
                    inGameMode() === 'match'
                ) {
                    <!-- Action Replays -->
                    <div>
                        <div
                            [dcBgColor]="menuSectionHeaderBackgroundColor()"
                            dcTypography="bulevar-24"
                            [dcColor]="menuTextColor()"
                            class="px-4 py-2"
                            [translate]="'ACTION_REPLAYS'"
                            i18n="@@ACTION_REPLAYS">
                            Action Replays
                        </div>
                        <div
                            [dcBgColor]="menuSectionBackgroundColor()"
                            class="dc-surface-page divide-y-1 divide-divider-color">
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.enableActionReplays()"
                                mode="game_menu"
                                (itemChange)="toggleActionReplays()"
                                [translate]="'ENABLE_ACTiON_REPLAYS'"
                                i18n="@@ENABLE_ACTiON_REPLAYS">
                                Enable Action Replays
                            </app-toggle-switch>
                            <app-toggle-switch
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.promptActionReplay()"
                                mode="game_menu"
                                [disabled]="!preferenceService.enableActionReplays()"
                                (itemChange)="togglePromptActionReplay()"
                                [translate]="'SHOW_ACTION_REPLAY_SLIDER'"
                                i18n="@@SHOW_ACTION_REPLAY_SLIDER">
                                Show Action Replay slider
                            </app-toggle-switch>
                        </div>
                    </div>
                }

                <!-- DartBot -->
                @if (hasDartBotSettings() && hasDartBot() && !inGameDetails().is_online) {
                    <div>
                        <div
                            dcBgColor="flight-blue-3"
                            dcTypography="bulevar-24"
                            dcColor="dark-treble-green-2"
                            class="px-4 py-2"
                            [translate]="'DARTBOT_SETTINGS'"
                            i18n="@@DARTBOT_SETTINGS">
                            DartBot settings
                        </div>
                        <div dcBgColor="form-control-bg" class="dc-surface-page divide-y-1 divide-divider-color">
                            <app-toggle-switch
                                dcTypography="geist-14-semibold"
                                [dcColor]="menuTextColor()"
                                class="block w-full px-4 py-2"
                                [model]="preferenceService.callDartBot() && preferenceService.allowCaller()"
                                mode="game_menu"
                                [disabled]="!preferenceService.allowCaller()"
                                (itemChange)="toggleCallDartBot()"
                                [translate]="'SCORE_SOUNDS'"
                                i18n="@@SCORE_SOUNDS">
                                Score sounds
                            </app-toggle-switch>

                            @if (dartBotOverallSettings().callDartBotYouRequire) {
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    [dcColor]="menuTextColor()"
                                    class="block w-full px-4 py-2"
                                    [model]="
                                        preferenceService.callDartBotYouRequire() && preferenceService.allowCaller()
                                    "
                                    mode="game_menu"
                                    [disabled]="!preferenceService.allowCaller()"
                                    (itemChange)="toggleCallDartBotYouRequire()"
                                    [translate]="'CALL_YOU_REQUIRE'"
                                    i18n="@@CALL_YOU_REQUIRE">
                                    'You require'
                                </app-toggle-switch>
                            }

                            @if (dartBotOverallSettings().autocompleteDartBotGame) {
                                <app-toggle-switch
                                    dcTypography="geist-14-semibold"
                                    dcColor="dark-treble-green-2"
                                    class="block w-full px-4 py-2"
                                    [model]="preferenceService.autocompleteDartBot()"
                                    mode="game_menu"
                                    (itemChange)="toggleAutocompleteDartBot()"
                                    [translate]="'AUTOCOMPLETE_DARTBOT'"
                                    i18n="@@AUTOCOMPLETE_DARTBOT">
                                    Auto-complete DartBot
                                </app-toggle-switch>
                            }

                            <div
                                [dcBgColor]="menuSectionBackgroundColor()"
                                class="dc-surface-page flex flex-col divide-y-1 divide-divider-color px-4">
                                <div class="flex flex-col justify-center space-x-2 py-2">
                                    <span
                                        dcTypography="geist-12-semibold"
                                        [translate]="'THROW_SPEED'"
                                        i18n="@@THROW_SPEED">
                                        Throw speed
                                    </span>
                                    <div class="!mx-0 flex flex-row items-center">
                                        <dc-range-slider
                                            class="-my-4 w-full"
                                            [min]="0"
                                            [max]="15"
                                            [step]="0.5"
                                            [value]="displayedDartBotTimeout()"
                                            (interactionStart)="disableMenuSwipeGesture()"
                                            (interactionEnd)="enableMenuSwipeGesture()"
                                            (valueChange)="updateDartBotTimeout($event)"></dc-range-slider>

                                        <span
                                            class="w-1/4 text-right"
                                            dcTypography="geist-12-semibold"
                                            [dcColor]="menuTextColor()">
                                            {{ displayedDartBotTimeout() }}s
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <!-- Theme -->
                <div>
                    <div
                        [dcBgColor]="menuSectionHeaderBackgroundColor()"
                        dcTypography="bulevar-24"
                        [dcColor]="menuTextColor()"
                        class="px-4 py-2"
                        [translate]="'THEME'"
                        i18n="@@THEME">
                        Theme
                    </div>
                    <div
                        [dcBgColor]="menuSectionBackgroundColor()"
                        class="dc-surface-page divide-y-1 divide-divider-color">
                        <app-toggle-switch
                            dcTypography="geist-14-semibold"
                            [dcColor]="menuTextColor()"
                            class="block w-full px-4 py-2"
                            [model]="accessibilityMode()"
                            mode="game_menu"
                            (itemChange)="toggleAccessibilityMode()"
                            [translate]="'ACCESSIBILITY_MODE'"
                            i18n="@@ACCESSIBILITY_MODE">
                            Accessibility mode
                        </app-toggle-switch>
                    </div>
                </div>
            </div>
        }

        @if (authService.user?.is_ultimate === false) {
            <div class="mx-2 mt-4 rounded-[1.5rem] bg-ultimate-blue-gradient p-[2px]" (click)="openUpgradeDialog()">
                <button
                    dcButton
                    type="button"
                    size="medium"
                    dcGradientDirection="right-to-left"
                    dcBgColor="ultimate-blue-gradient"
                    class="flex w-full space-x-1">
                    <dc-icon icon="home" size="sm" dcColor="wire-white-fixed" />
                    <span dcColor="wire-white-fixed" [translate]="'UPGRADE_TO_ULTIMATE'" i18n="@@UPGRADE_TO_ULTIMATE"
                        >Upgrade to Ultimate
                    </span>
                </button>
            </div>
        }

        <div
            class="mt-auto flex justify-center gap-2 pb-2 pt-4"
            dcTypography="geist-9-semibold"
            [dcColor]="menuTextColor()">
            @if (version) {
                <p class="text-center">v{{ version }}</p>
            } @else if (!isWeb) {
                <p class="text-center">v0.0.0</p>
            }
        </div>
    </div>
</ion-menu>
